<template>
</template>

<script>
import utils from "@/services/utils";

export default {
  name: "CheckService",
  created: function () {
    var user = this.$store.state.auth.user_info.user;
    switch (user.service_type) {
      case 'btfs':
        // this.$router.push('/btfs')
        this.$router.push({name: 'BTFSBoard'});
        break;
      case 'thcs':
        this.$router.push({name: 'THCSBoard'});
        break;
      case 'toc':
        this.$router.push({name: 'TOCBoard'});
        break;      
      case 'srds':
        this.$router.push({name: 'SRDSBoard'});
        break;  
      case 'swfm':
        this.$router.push({name: 'SWFMBoard'});
        break;        
      case 'pwdm':
        this.$router.push({name: 'PWDMBoard'});
        break;
      case 'ruler':
        this.$router.push({name: 'RULERBoard'});
        break;      
      case 'sslm':
        this.$router.push({name: 'SSLMBoard'});
        break;     
      case 'smarcle':
        this.$router.push({name: 'SMARCLEBoard'});
        break;                                 
      case 'sis':
      default:
        this.$router.push({name: 'Dashboard'});
    }
  },
};
</script>
